import BaseChip from './BaseChip.vue';

export { BaseChip };
